/* eslint-disable */
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import ECharts from 'echarts-for-react';
import { Chip, TableCell, TableRow } from "@mui/material";
import { getDiagnosisResultVibrationSensorsGraphDayByQuery } from "components/axios/equipmentAlertsAxios";
import MainCard from "components/MainCard";

const chartDataInit = {
    darkmode:true,
    textStyle : {
        color : '#ffffff'
    },
    tooltip: {
      trigger: 'axis'
    },
    legend: {
        data : [],
        left : 20,
        top: 0,
        backgroundColor : '#fff'
    },
    grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
    },
    xAxis: {
        type: 'category',
        boundaryGap: false,
        data: [ ]
    },
    yAxis: {
        type: 'value'
    },
    series: [ ]
}

function EquipmentPartSensorsReportGraphs({equipment, equipmentPart, sensorPosition, isPrinting=false}) {
    const [dailyGraphDatas, setDailyGraphDatas] = useState(null);
    const [equipmentPartName, setEquipmentPartName] = useState('');
    const { t } = useTranslation();
    const [options, setOptions] = useState({chartDataInit});

    useEffect(()=>{
        if(sensorPosition) {
            // console.log(sensorPosition)
            // let graphParam = {"equipmentId":equipment.id};
            // let graphVibrationParam = {"equipmentPart.id":sensor.equipmentPart.id, position : sensor.position};
            let graphVibrationParam = {"sensorPosition.id":sensorPosition.id};
            if (sensorPosition.sensorType === 'V') {    // 진동센서
                getDiagnosisResultVibrationSensorsGraphDayByQuery(graphVibrationParam).then((data)=> {
                    // console.log(data)
                    if (data && data._embedded) {
                        let list = data._embedded.groupByDailyDiagnosisResultVibrations;
                        list.sort(function(a,b) {
                            const upperCaseA = a.ymd.toUpperCase();
                            const upperCaseB = b.ymd.toUpperCase();
                            if (upperCaseA > upperCaseB) return 1;
                            if (upperCaseA < upperCaseB) return -1;
                            if (upperCaseA === upperCaseB) return 0;
                        });
                        let optionsCopy = {...chartDataInit};
                        let chartDataCopy = JSON.parse(JSON.stringify(optionsCopy));
                        let overallXs = [];
                        let overallYs = [];
                        let overallZs = [];
                        list.map(function(item, i) {
                            chartDataCopy.xAxis.data.push(item.ymd);
                            overallXs.push(item.overallShaft.toFixed(2));
                            overallYs.push(item.overallHorizon.toFixed(2));
                            overallZs.push(item.overallVertical.toFixed(2));
                            if (i==0) {
                                setEquipmentPartName(item.equipmentPartName)
                            }
                        });
                        chartDataCopy.series.push({name:t('message.common.subtitle.axis'), type: 'line', lineStyle : {width:5, type:'solid'}, symbolSize : 8, data : overallXs});
                        chartDataCopy.series.push({name:t('message.common.subtitle.radius'), type: 'line', lineStyle : {width:5, type:'solid'}, symbolSize : 8, data : overallYs});
                        chartDataCopy.series.push({name:t('message.common.subtitle.vertical'), type: 'line', lineStyle : {width:5, type:'solid'}, symbolSize : 8, data : overallZs});
                        chartDataCopy.legend.data.push(t('message.common.subtitle.axis'));
                        chartDataCopy.legend.data.push(t('message.common.subtitle.radius'));
                        chartDataCopy.legend.data.push(t('message.common.subtitle.vertical'));
                        setOptions(chartDataCopy);
                        setDailyGraphDatas(chartDataCopy);
                    } else {
                        setOptions(chartDataInit);
                        setDailyGraphDatas(null);
                    }
                })
            }
        }
    },[sensorPosition, equipment]);
      return (
        <>
            {dailyGraphDatas &&
            <TableRow>
                <TableCell className="td title" align="center" style={{width:"200px"}}>
                    {equipment.name} {equipmentPart.position}({sensorPosition.positionNoBySensorType}).{equipmentPartName}
                </TableCell>
                <TableCell className="td graph" align="center">            
                    <div className="row">
                        <div className="mixed-chart" style={{display: "grid"}}>
                            {dailyGraphDatas &&
                            <MainCard content={false}>
                                {/* <Chip label={(sensor.sensorType === 'V' ? t('message.common.chip.vibration.trend.graph') : t('message.common.chip.elongation.trend.graph'))+" ("+equipmentPartName+")"} color="primary" /> */}
                                <Chip label={t('message.common.chip.vibration.trend.graph')} color="primary" />
                                {isPrinting ? 
                                <ECharts
                                    option={options}
                                    opts={{ renderer: 'svg',  height: '250px' }}
                                />
                                :
                                <ECharts
                                    option={options}
                                    opts={{ renderer: 'svg', height: '250px' }}
                                />
                                }
                            </MainCard>
                            }
                        </div>
                    </div>
                </TableCell>
            </TableRow>
            }
        </>
      )
  //  }
}

export default EquipmentPartSensorsReportGraphs;